<template lang="pug">
.order-list
  list-search(@onSearch="onSearch" @onExport="exportData")

  el-tabs(v-model="searchData.statusCode" @tab-click="getOrderList(1)")
    el-tab-pane(v-for="item, index in orderStatusLs" :key="index" :name="item.value")
      .tab-item(slot="label")
        span {{item.label}}
        span.order-count(v-if="item.count >= 0") {{item.count}}

  ul.list( v-if="totalCount > 0")
    li(v-for="(item, index) in orderList" :key="item.bizOrder.bizOrderId + refreshCount")
      order-list-item(:item="item" :is-header="index === 0"  @onTimeEnd="onTimeEnd"
        @updatePrice="updatePrice" @updateTime="updateTime"  @open-verify="openVerify" :showSignTip="index === firstShowInviteTipIndex && isShowInviteSignTip" @close-tip="isShowInviteSignTip = false")

  el-pagination.pagination(background :page-size="pageSize" v-if="totalCount > 0" @size-change="handleSizeChange"
    :current-page="pageNo" layout="total, sizes, prev, pager, next, jumper" prev-text="上一页"
    :total="totalCount" @current-change="getOrderList" next-text="下一页" :page-sizes="[20, 40, 60, 80]")

  .empty(v-if="totalCount === 0")
    img(src="@/assets/order-empty.png")
    .tips 暂时没有订单

  update-price(v-model="isShowDialog" :item="updatePriceItem" v-if="isShowDialog" @updateSuccess="getOrderList(pageNo)")

  el-dialog(:visible.sync="isShowDelayTime" title="延长订单付款时间" center)
    el-form
      el-form-item(label="选择订单延长时间")
        el-select.w-150(v-model="delayTime" placeholder="选择订单延长时间" size="small")
          el-option(label="延长1小时" :value="1")
          el-option(label="延长3小时" :value="3")
          el-option(label="延长5小时" :value="5")
          el-option(label="延长8小时" :value="8")
          el-option(label="延长24小时" :value="24")
          el-option(label="延长48小时" :value="48")
    p 延长后将在{{ delayAfterTime() }}后取消
    .hint 提示：延长后订单的付款时间将会延长
    .dialog-footer(slot="footer")
      el-button(@click="isShowDelayTime = false") 取 消
      el-button(type="primary" @click="confirmDelayTime") 确 认
  real-name-verify(:visible.sync="showVerify" :showRange="showRange" @close="showRange = 0")
</template>

<script>
import Cookies from '@/common/utils/cookie'
const getUserId = () => Cookies.get('_uid') || ''

import orderListItem from './components/orderListItem'
import updatePrice from './components/updatePrice'
import dateFormat from '@/common/utils/date'
import { FILE_ACCESS_PRIVATE } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'
import { validNumber } from '@/common/utils/validate.js'
import ListSearch from './components/listSearch'
import { mapGetters } from 'vuex'
import RealNameVerify from '@/components/sign/info-verify'
import { CONTRACT_STATUS } from 'common/constants'
import cookie from 'common/utils/cookie'

export default {
  name: 'orderList',
  components: {
    orderListItem,
    updatePrice,
    ListSearch,
    RealNameVerify
  },
  computed: {
    ...mapGetters(['userCurrentOrg']),
    orderTotalFee() {
      let totalFee = 0
      this.suborderList &&
        this.suborderList.forEach(item => {
          if (item.updatePrice) {
            item.totalPrice = item.updatePrice * item.buyAmount * this.getWeightUnit(item.bizOrder)
            item.totalPrice = +parseInt((item.totalPrice * 100).toPrecision(12)) / 100
          }
          totalFee += item.totalPrice
        })
      return totalFee
    },
    firstShowInviteTipIndex() {
      return this.orderList.findIndex(
        i =>
          !['CANCEL', 'CLOSED'].includes(i.bizOrder.orderStatus) &&
          [CONTRACT_STATUS.INIT.key, CONTRACT_STATUS.SELLER_UNSIGNED.key].includes(i.detailStatus)
      )
    }
  },
  data() {
    let orderStatusLs = [
      {
        label: '全部',
        value: 'ALL'
      },
      {
        label: '待付款',
        value: 'WAITING_PAY'
      },
      {
        label: '待发货',
        value: 'WAITING_DELIVERY'
      },
      {
        label: '待收货',
        value: 'SHIPPING'
      },
      {
        label: '待补款',
        value: 'WAITING_REPLENISH'
      },
      {
        label: '已完成',
        value: 'FINISH'
      },
      {
        label: '已关闭',
        value: 'CANCEL, REFUNDED'
      }
    ]
    return {
      searchData: {
        statusCode: 'ALL'
      },
      orderList: [],
      shopInfo: {},
      totalCount: 0,
      pageNo: 1,
      pageSize: 20,
      isShowDialog: false,
      updatePriceItem: {},
      refreshCount: 0,
      isShowDelayTime: false,
      delayTime: 1,
      showVerify: false,
      showRange: 0,
      isShowInviteSignTip: false,
      orderStatusLs
    }
  },
  methods: {
    showSignInviteTip() {
      // 存储是否展示过邀请卖家签约的引导提示
      const key = 'signInviteTipShow'
      let storeSignInviteTip = JSON.parse(window && window.localStorage.getItem(key)) || {}
      let uid = getUserId()
      if (
        !storeSignInviteTip[uid] ||
        (storeSignInviteTip[uid] && Number(storeSignInviteTip[uid] || 0) < 1)
      ) {
        this.isShowInviteSignTip = true
        storeSignInviteTip[uid] = Number(storeSignInviteTip[uid] || 0) + 1
        window && window.localStorage.setItem(key, JSON.stringify(storeSignInviteTip))
      } else {
        this.isShowInviteSignTip = false
      }
    },
    /** 查询 */
    onSearch(data) {
      this.searchData = Object.assign(this.searchData, data)
      if (validNumber(this.searchData.bizOrderId)) {
        this.getOrderList()
        this.getorderCount()
      } else {
        this.$message.warning('请输入正确的订单号!')
        return false
      }
    },
    /** 查询订单数量 */
    async getorderCount() {
      try {
        const result = await this.$post(
          'trademanager.pageQueryByConditionByEs',
          {
            orderForSellerQuery: Object.assign(this.searchData, {
              sellerId: this.userCurrentOrg.id,
              orgId: this.userCurrentOrg.id,
              shopId: this.shopInfo.id
            })
          },
          { notNeedLoading: true }
        )
        if (result.success) {
          if (result.data[0]) {
            const oderCount = result.data[0]
            const list = JSON.parse(JSON.stringify(this.orderStatusLs))
            list.forEach(item => {
              if (oderCount.waitPayCount >= 0 && item.value === 'WAITING_PAY') {
                item.count = oderCount.waitPayCount
              }
              if (oderCount.waitDeliveryCount >= 0 && item.value === 'WAITING_DELIVERY') {
                item.count = oderCount.waitDeliveryCount
              }
              if (oderCount.shippingCount >= 0 && item.value === 'SHIPPING') {
                item.count = oderCount.shippingCount
              }
              if (oderCount.waitReplenishCount >= 0 && item.value === 'WAITING_REPLENISH') {
                item.count = oderCount.waitReplenishCount
              }
            })
            this.orderStatusLs = JSON.parse(JSON.stringify(list))
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 获取订单列表 */
    async getOrderList(page, notNeedLoading) {
      this.showSignInviteTip()
      this.pageNo = page || 1
      try {
        const result = await this.$post(
          'trademanager.pageQueryBizOrderForSellerByEs',
          {
            orderForSellerQuery: Object.assign(this.searchData, {
              sellerId: this.userCurrentOrg.id,
              orgId: this.userCurrentOrg.id,
              shopId: this.shopInfo.id
            }),
            pageNo: this.pageNo,
            pageSize: this.pageSize
          },
          { notNeedLoading }
        )
        if (result.success) {
          this.refreshCount++
          this.orderList = result.data[0].list || []
          this.totalCount = result.data[0].totalCount
          this.orderList.forEach(item => {
            let detailOrders = item.detailOrders
            detailOrders &&
              detailOrders.forEach(subItem => {
                let bizOrder = subItem.bizOrder
                if (!bizOrder) {
                  bizOrder = {}
                }
                if (!bizOrder.processFee) {
                  bizOrder.processFee = 0
                }
                if (!bizOrder.storageFee) {
                  bizOrder.storageFee = 0
                }
                if (!bizOrder.commissionFee) {
                  bizOrder.commissionFee = 0
                }
                if (!bizOrder.promiseInterestSubsidyFee) {
                  bizOrder.promiseInterestSubsidyFee = 0
                }
                if (!bizOrder.settleAdjustFee) {
                  bizOrder.settleAdjustFee = 0
                }
                if (!bizOrder.logisticsPrice) {
                  bizOrder.logisticsPrice = 0
                }
              })
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 导出订单列表 */
    async exportData(data) {
      if (this.totalCount > 2000) {
        return this.$message.error('最多导出2000条数据')
      }
      this.searchData = Object.assign(this.searchData, data)
      try {
        const result = await this.$post('trademanager.exportBizOrderForSeller', {
          orderForSellerQuery: Object.assign(this.searchData, {
            sellerId: this.userCurrentOrg.id,
            orgId: this.userCurrentOrg.id
          })
        })
        if (result.success) {
          if (result.data[0].url) {
            let downloadElement = document.createElement('a')
            downloadElement.href = `${FILE_ACCESS_PRIVATE}${
              result.data[0].url
            }&_tk=${getWebToken()}`
            document.body.appendChild(downloadElement)
            downloadElement.click()
            window.URL.revokeObjectURL(
              `${FILE_ACCESS_PRIVATE}${result.data[0].url}&_tk=${getWebToken()}`
            )
            document.body.removeChild(downloadElement)
          } else {
            this.$message.error('导出数据失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },

    updatePrice(item) {
      this.updatePriceItem = item
      this.isShowDialog = true
    },
    /** 修改pageSzie */
    handleSizeChange(val) {
      this.pageSize = val
      this.getOrderList()
    },
    getWeightUnit(order) {
      let out = 1
      if (order.pieceWeightUnit === 'KG' || order.pieceWeightUnit === 'TON') {
        out = order.pieceWeight / 10000
      }
      return out
    },
    /** 显示延长订单付款时间的弹窗 */
    updateTime(item) {
      this.isShowDelayTime = true
      this.delayTimeItem = item
      this.delayTime = 1
    },
    /** 确认延长订单付款时间 */
    async confirmDelayTime() {
      try {
        const result = await this.$post('trademanager.delayOrderPayTimeForSeller', {
          bizOrderId: this.delayTimeItem.bizOrder.bizOrderId,
          delayType: this.delayTime
        })
        if (result.success) {
          if (result.data[0].value) {
            this.$message.success('订单付款时间延长成功')
            this.isShowDelayTime = false
            this.getOrderList(this.pageNo)
          } else {
            this.$message.error('订单付款时间延长失败')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    onTimeEnd(item) {
      // 订单超时, 后台改变状态, 前台轮询刷新数据
      let count = 0
      let timeId = setInterval(() => {
        try {
          count++
          if (validNumber(this.searchData.bizOrderId)) {
            this.getOrderList(this.pageNo, true)
            this.getorderCount()
          } else {
            this.$message.warning('请输入正确的订单号!')
            clearInterval(timeId)
            return false
          }
          let newItem = this.orderList.find(order => {
            return order.bizOrder.bizOrderId === item.bizOrder.bizOrderId
          })
          if (
            (newItem && newItem.bizOrder && newItem.bizOrder.orderStatus !== 'WAITING_PAY') ||
            count > 2
          ) {
            clearInterval(timeId)
          }
        } catch (err) {
          console.log(err)
          clearInterval(timeId)
        }
      }, 5000)
    },
    delayAfterTime() {
      let result = 0
      if (this.delayTimeItem) {
        let ss = this.delayTimeItem.bizOrderPayTimeOut + this.delayTime * 3600
        let hh = Math.floor(ss / 3600)
        let mm = Math.floor((ss - hh * 3600) / 60)
        ss = ss - hh * 3600 - mm * 60
        result = `${hh}小时${mm}分钟${ss}秒`
      }
      return result
    },
    openVerify(range = 0) {
      this.showRange = range
      this.showVerify = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-list
  .list
    position relative
    overflow-x scroll
    overflow-y hidden

    .order-list-item
      min-width 900px

  .empty
    margin-top 150px
    text-align center

    img
      width 150px
      height 150px

    .tips
      text-align center
      margin-top 20px
      color #999
.hint
  margin-top 10px
  color #999
  font-size 12px
.order-count
  color #cd974c
  font-size 15px
  font-weight 500
  margin-left 5px
</style>
